import {ApplicationState} from "../reducers";
import {ThunkAction} from "redux-thunk";
import {apiError, apiPut, apiRequest, CommonAction} from "./common";
import {Order, OrderSearchParams, OrderUpdate, Transaction} from "../models/order";
import {compact, clone} from "lodash";

export const ORDERS_LOADING = "ORDERS_LOADING";
export const ORDERS_LOADED = "ORDERS_LOADED";
export const ORDERS_DETAIL_LOADED = "ORDERS_DETAIL_LOADED";
export const ORDERS_DETAIL_UPDATE = "ORDERS_DETAIL_UPDATE";
export const ORDERS_UPDATE_SEARCH_PARAMS = "ORDERS_UPDATE_SEARCH_PARAMS";
export const ORDERS_API_ERROR = "ORDERS_API_ERROR";
export const ORDERS_DECRYPTED_TRANS = "ORDERS_DECRYPTED_TRANS";
export const ORDERS_SET_KEY = "ORDERS_SET_KEY";
export const ORDERS_EMAIL_SENT = "ORDERS_EMAIL_SENT";

type OrdersActionResponse = ThunkAction<Promise<OrdersAction>, ApplicationState, {}>;

export interface OrdersAction extends CommonAction {
    loading?: boolean;
    orderSearchParams?: OrderSearchParams;
    orderList?: Order[];
    orderDetail?: Order;
    transactions?: Transaction[];
    key?: string;
}

export function getOrderList(params: OrderSearchParams): OrdersActionResponse {
    return dispatch => {
        dispatch({type: ORDERS_LOADING});
        const urlParams = compact([
            params.search ? `search=${encodeURIComponent(params.search)}` : null,
            params.maxDate ? `maxDate=${encodeURIComponent(params.maxDate)}` : null,
            params.minDate ? `minDate=${encodeURIComponent(params.minDate)}` : null,
        ]).join("&");
        return apiRequest<Order[]>(`/orders?${urlParams}`)
            .then(response => {
                return dispatch({
                    type: ORDERS_LOADED,
                    orderList: response
                }) as OrdersAction;
            })
            .catch(err => dispatch(apiError(ORDERS_API_ERROR, err)));
    };
}

export function getOrderDetail(id: string): OrdersActionResponse {
    return dispatch => {
        dispatch({type: ORDERS_LOADING});
        return apiRequest<Order>(`/orders/${id}`)
            .then(response => {
                return dispatch({
                    type: ORDERS_DETAIL_LOADED,
                    orderDetail: response
                }) as OrdersAction;
            })
            .catch(err => dispatch(apiError(ORDERS_API_ERROR, err)));
    };
}

export function resendOrderConfirmationEmail(id: string): OrdersActionResponse {
    return dispatch => {
        dispatch({type: ORDERS_LOADING});
        return apiPut<Order>(`/orders/${id}/send_confirmation_email`, {})
            .then(() => {
                return dispatch({
                    type: ORDERS_EMAIL_SENT
                }) as OrdersAction;
            })
            .catch(err => dispatch(apiError(ORDERS_API_ERROR, err)));
    };
}

export function getDecryptedTransactions(id: string, key: string): OrdersActionResponse {
    return dispatch => {
        dispatch({type: ORDERS_LOADING});
        return apiPut<Transaction[]>(`/orders/${id}/transactions/decrypt`, key, "text/plain")
            .then(response => {
                return dispatch({
                    type: ORDERS_DECRYPTED_TRANS,
                    transactions: response
                }) as OrdersAction;
            })
            .catch(err => {
                dispatch(apiError(ORDERS_API_ERROR, err));
                dispatch(setKey(""));
            });
    };
}

export function setKey(key: string): OrdersAction {
    return {type: ORDERS_SET_KEY, key};
}

export function updateSearchParams(params: OrderSearchParams): OrdersAction {
    return {
        type: ORDERS_UPDATE_SEARCH_PARAMS,
        orderSearchParams: params
    };
}

export function setErrorMessage(msg: string): OrdersAction {
    return {
        type: ORDERS_API_ERROR,
        errorMessage: msg
    };
}

export function updateOrderDetailStore(order: Order): OrdersAction {
    return {
        type: ORDERS_DETAIL_UPDATE,
        orderDetail: clone(order)
    };
}

export function updateOrder(order: OrderUpdate): OrdersActionResponse {
    return dispatch => {
        dispatch({type: ORDERS_LOADING});
        return apiPut<Order>(`/orders/${order.orderId}`, order)
            .then(response => {
                return dispatch({
                    type: ORDERS_DETAIL_LOADED,
                    orderDetail: response
                }) as OrdersAction;
            })
            .catch(err => dispatch(apiError(ORDERS_API_ERROR, err)));
    };
}



// WEBPACK FOOTER //
// ./src/actions/orders.ts